'use strict';

import React, { Component } from 'react';
import ValidationOverlay from './validationOverlay.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Grid, Box } from '@material-ui/core';
import InputText, { InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';


class Installateur extends Component{

	state ={
		//Initiate Default User
		msg: "",
		popupState: this.props.popupState,
		popupStateValidation: false,
		Type: "Male",
		name: "",
		email: "",
		phone: "",
		company: "", 
		city: "",
		errmsg: "",
		urlAgent: "",
		//Info on the electrical equipment
		agentR: "DefaultInstallerSchemaID",
		agentQ: [
			{
			id: "DefaultInstallerSchemaID",
			name: "DefaultInstallerSchemaID"
			}
		],
		}
	getInitialState() {
		return {
		//Initiate Default User
		msg: "",
		popupState: this.props.popupState,
		popupStateValidation: false,
		Type: "Male",
		name: "",
		email: "",
		phone: "",
		company: "", 
		city: "",
		errmsg: "",
		urlAgent: "",
		agentR: "DefaultInstallerSchemaID",
		agentQ: [
			{
			id: "DefaultInstallerSchemaID",
			name: "DefaultInstallerSchemaID"
			}
		]
		};
	}
	getInitialStateWithoutOption() {
		return {
		msg: "",
		popupState: this.props.popupState,
		popupStateValidation: false,
		Type: "Male",
		name: "",
		email: "",
		phone: "",
		company: "",
		city: "",
		errmsg: "",
		urlAgent: "",
		agentR: "DefaultInstallerSchemaID",
		};
	}
	onValidation= async (e) => {
		e.preventDefault();
		//Test if ok
		if (this.state.email === ''&& this.state.phone === '') {
		this.setState({errmsg: "Email And Phone of agent can not be empty"});
		return;
		}
		var msg = "Enregistrement d'un nouveau installateur , nom : " + this.state.name + ", email : '" + this.state.email + "' , téléphone :'" + this.state.phone + "' , compagnie : '" + this.state.company + "' , ville : '" + this.state.city + "'";
		var url = "/installer/new2?name=" + this.state.name + "&email=" + 
		this.state.email + "&phone=" + this.state.phone + 
		"&company=" + this.state.company + "&city=" + this.state.city+
		"&agentR="+this.state.agentR;

		//Active Pop up Security
		this.setState({popupStateValidation: true, msg: msg, urlAgent: url});
	}

	onValidationSucceed= async () => {
		this.setState(this.getInitialState());
		this
		.props
		.onCloseOverlay();
	}
	onCancelation= async () => {
		this.setState({popupStateValidation: false})
	}
	componentDidMount= async () => {
		console.log('[DEBUG], paygoGet All, load schema ');
		let listSchema = [];
		try {
		const response = await fetch('/schema/list', {
			method: 'GET',
			headers: {
			'Content-Type': 'application/json',
			'X-CSRF-TOKEN': document.getElementsByName("_csrf")[0].content
			},
			credentials: 'same-origin'
		});
		const resp = await response.json();
		console.log("[INFO], Response for list of all schema : , ");
		console.log(resp);
		if (resp.content.lenght == 0) {
			console.log("[ERROR], getting schema getAll response ", resp)
			return;
		}
		//Parse content
		resp.content.map( item => {
			console.log(item);
			listSchema = listSchema.concat({id: item.id, name: item.name});
			});
		this.setState({
			electricQ: this.state.electricQ.concat(listSchema),
			photo1Q: this.state.photo1Q.concat(listSchema),
			agentQ:this.state.agentQ.concat(listSchema),
			solarQ: this.state.solarQ.concat(listSchema),
			otherQ: this.state.otherQ.concat(listSchema)
		});
		} catch (err) {
		console.log("[ERROR], getting schema for installater getAll data", err)
		}
	}
	componentWillUnmount() {}
	render() {
		console.log('[DEBUG], User Questions', this.state.userQ);
		return (
		// <Grid className={this.props.popupState}>
		//   <Grid className="card">
		//     <div className="card-header">
		//       <h2>Enregistrer un nouvel installateur
		//         <small>Nouveau installateur</small>
		//       </h2>
		//     </div>

		//     <gR id="data-table-basic-header" className="bootgrid-header container-fluid">
		//       <Grid className="card-body card-padding">
		<PopUp
			title="Nouvel installateur"
			close={this.props.onCloseOverlay}
			submitAction={this.onValidation}
		>
			<Box>
				<b style={{ 'color': 'red' }}>{this.state.errmsg} </b>
			</Box>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<InputSelectNative
                            label="Type"
							labelWidth="80"
                            value={this.state.Type}
                            onChange={e => this.setState({Type : e.target.value})}
                            options={[
                                <option key="Male" value="Male">Male</option>,
                                <option key="Female" value="Female">Female</option>
                            ]}
                        />
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Nom"
							value={this.state.name}
							onChange={e => this.setState({name: e.target.value})}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Téléphone"
							value={this.state.phone}
							onChange={e => this.setState({phone: e.target.value})}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Email"
							value={this.state.email}
							onChange={e => this.setState({email: e.target.value})}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Entrprise"
							value={this.state.company}
							onChange={e => this.setState({company: e.target.value})}
						/>
						
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Ville"
							value={this.state.city}
							onChange={e => this.setState({city: e.target.value})}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputSelectNative
                            label="Questionnaire Enregistrement technicien"
							labelWidth="250"
                            value={this.state.agentR}
                            onChange={e => this.setState({agentR : e.target.value})}
                            options={this.state.agentQ.map((item) => (
								<option key={item.id} value={item.id}>{item.name}
								</option>
							))}
                        />
					</Grid>

				</Grid>
				{this.state.popupStateValidation &&
					<ValidationOverlay
						msg={this.state.msg}
						// popupStateButton={this.state.popupStateValidation}
						url={this.state.urlAgent}
						onValidation={this.onValidationSucceed}
						onCancelation={this.onCancelation}
					/>
				
				}
		</PopUp>
		);
	}
};
export default Installateur

